import { ButtonBase, Stack, Typography } from "@mui/material"
import CreditCardIcon from '@mui/icons-material/CreditCard'
import PaymentsIcon from '@mui/icons-material/Payments'
import PixIcon from '@mui/icons-material/Pix'
import type { IconePagamento, MetodoPagamento } from "./payment-methods"

const ICONES: Record<IconePagamento, JSX.Element> = {
    credito: <CreditCardIcon sx={{ fontSize: '5rem' }} />,
    debito: <PaymentsIcon sx={{ fontSize: '5rem' }} />,
    pix: <PixIcon sx={{ fontSize: '5rem' }} />,
}

interface PaymentMethodCardProps {
    metodo: MetodoPagamento
    onSelecionar: (metodo: MetodoPagamento) => void
    spanCompleto?: boolean
}

export default function PaymentMethodCard({ metodo, onSelecionar, spanCompleto = false }: PaymentMethodCardProps): JSX.Element {
    return (
        <ButtonBase
            onClick={() => onSelecionar(metodo)}
            sx={{
                gridColumn: spanCompleto ? '1 / -1' : 'auto',
                justifySelf: spanCompleto ? 'center' : 'stretch',
                width: spanCompleto ? 'calc(50% - 12px)' : '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                p: 4,
                minHeight: 160,
                borderRadius: 4,
                color: '#fff',
                backgroundColor: metodo.cor,
                transition: 'transform 0.2s ease-in-out, filter 0.2s ease-in-out',

                '&:hover': {
                    filter: 'brightness(0.92)',
                    transform: 'translateY(-2px)',
                },

                '&:active': {
                    transform: 'scale(0.98)',
                },
            }}
        >
            {ICONES[metodo.icone]}

            <Typography variant="h2" sx={{ fontWeight: 'bold', color: 'inherit' }}>
                {metodo.rotulo}
            </Typography>
        </ButtonBase>
    )
}